import { isWileyClientFECheck } from "handlers/features";
import { toast } from "react-toastify";

const Toaster = (message, type, time) => {
  const wileyConfig = isWileyClientFECheck()
    ? {
        hideProgressBar: false,
        autoClose: false,
      }
    : {};

  const commonProps = {
    autoClose: time || 2500,
    theme: "colored",
    closeOnClick: true,
    pauseOnHover: true,
    newestOnTop: true,
    ...wileyConfig,
  };

  switch (type) {
    case "success":
      toast.success(message, {
        position: "top-right",
        ...commonProps,
      });
      break;
    case "error":
      toast.error(message, {
        position: "top-right",
        ...commonProps,
      });
      break;
    case "info":
      toast.info(message, {
        position: "top-right",
        ...commonProps,
      });
      break;
    case "warning":
      toast.warning(message, {
        position: "top-right",
        ...commonProps,
      });
      break;
    default:
      toast(message, {
        position: "top-right",
        ...commonProps,
      });
      break;
  }
};

export default Toaster;
